import ClientsAxios from '../../client-axios';
import { ResponseEntity } from '../../dto/response';

const { API_SERVER } = ClientsAxios;


export const StoreCurrencyService = async (payload: any) => {
    const responseEntity = new ResponseEntity()
    try {
        const response = await API_SERVER.post('currency-master/store', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const UpdateCurrencyService = async (payload: any) => {
    const responseEntity = new ResponseEntity()
    try {
        const response = await API_SERVER.post('currency-master/update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const FetchCurrencyListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('currency-master/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const DeleteCurrencyService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('currency-master/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}
